export const HEADER_HEIGHT = 64;
export const DESKTOP_NAV_HEIGHT = 44;
export const BASE_MOBILE_NAV_HEIGHT = 56;
export const BASE_MOBILE_PADDING_Y = 8;
export const IOS_MOBILE_PADDING_BOTTOM = 24;

export const NAV_ICON_COLOR_CLASSNAME = "lf-text-[var(--gray-11)]";
export const NAV_ICON_ACTIVE_COLOR_CLASSNAME = "lf-text-[var(--gray-12)]";
